import { formatAppliedFilters } from './core'

export const exportGridToCSV = (gridComponents, options = {}) => {
  const filename = options.filename || 'relatorio_dados.csv';

  const tableComponent = gridComponents?.BODY[0]?.Childrens?.find(
    (c) => c.Chave_Transacao_Componente === 'TABELA_RESULTADOS_GRID_001'
  );
  if (!tableComponent) throw new Error('Tabela não encontrada');

  // Usar dados filtrados se disponíveis, senão usar todos os dados
  let dataResult = [];
  if (options.filteredData && Array.isArray(options.filteredData)) {
    // Se há dados filtrados, usar eles (mesmo que seja array vazio após filtro)
    dataResult = options.filteredData;
  } else {
    // Se não há dados filtrados (primeira carga), usar dados originais
    try {
      dataResult = JSON.parse(
        tableComponent.Childrens.find(
          (c) => c.Chave_Transacao_Componente === 'PROCEDURE_RESULTSET'
        )?.Valor_Componente || '[]'
      ) || [];
    } catch (_) { dataResult = []; }
  }

  const columnsList = JSON.parse(
    tableComponent.Childrens.find(
      (c) => c.Chave_Transacao_Componente === 'TABELA_RESULTADOS_GRID_LISTA_COLUNAS'
    )?.Valor_Componente || '[]'
  );

  const extractTextFromStructured = (value) => {
    if (value == null) return '';
    if (typeof value !== 'string') return String(value);
    const trimmed = value.trim();
    if (!(trimmed.startsWith('[') || trimmed.startsWith('{'))) return value;
    try {
      const parsed = JSON.parse(trimmed);
      const arr = Array.isArray(parsed) ? parsed : [parsed];
      const texts = arr
        .filter((it) => it && typeof it === 'object' && it.tipo === 'texto' && it.valor != null && it.valor !== '')
        .map((it) => String(it.valor));
      return texts.join(' ');
    } catch (_) {
      return value;
    }
  };

  const exportColumns = columnsList.filter((col) => {
    if (col.Export === 'False' || col.Export === false) return false;
    const isImageCol = col.hasImage === 'True' || col.hasImage === true;
    if (!isImageCol) return true;
    // Para colunas com imagem, só inclui se alguma linha tiver texto útil
    return dataResult.some((row) => extractTextFromStructured(row[col.field] || '') !== '');
  });

  const headers = exportColumns.map((col) => col.header).join(',');
  const rows = dataResult.map((row) => {
    return exportColumns
      .map((col) => {
        let value = row[col.field] || '';
        const isImageCol = col.hasImage === 'True' || col.hasImage === true;
        if (isImageCol) {
          value = extractTextFromStructured(value);
        }
        if (typeof value === 'string') {
          if (value.length > 32000) value = value.substring(0, 32000) + '...';
          if (value.includes(',') || value.includes('"') || value.includes('\n')) {
            return '"' + value.replace(/"/g, '""') + '"';
          }
        }
        return value;
      })
      .join(',');
  });

  // Adicionar filtros no início se existirem
  let csvRows = [headers, ...rows];
  const filtersText = formatAppliedFilters(options.appliedFilters);
  
  if (filtersText) {
    // Adicionar linha de filtros no topo
    const filterLine = `"Filtros aplicados: ${filtersText.replace(/"/g, '""')}"`;
    // Adicionar vírgulas para manter a estrutura de colunas
    const extraCommas = ','.repeat(exportColumns.length - 1);
    csvRows.unshift(filterLine + extraCommas);
    csvRows.splice(1, 0, ''); // Adicionar linha vazia após os filtros
  }

  const csvContent = csvRows.join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export default exportGridToCSV


